var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g1 = _vm.datas.length
  var g2 = _vm.datas.length
  var l0 = _vm.__map(_vm.datas, function (item, i) {
    var $orig = _vm.__get_orig(item)
    var m0 = _vm.Type(item.station) == true && i != _vm.datas.length - 1
    var g0 = m0 ? item.station.includes("签收") : null
    var f0 = m0 ? _vm._f("Type")(item.station) : null
    return {
      $orig: $orig,
      m0: m0,
      g0: g0,
      f0: f0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g1: g1,
        g2: g2,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }